angular.module('FlexyBeautyApp.services').factory('Patch_Resource', [
  "$resource", "$location",
  function ($resource,$location) {
    let baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port()) + "/";
    return $resource(baseUrl + 'rest/patch-access', {}, {
      list: {method: 'GET', url: baseUrl + 'rest/patch-access'}
    });
  }
]);

angular.module('FlexyBeautyApp.services').factory('PatchSrv', ['Patch_Resource',
  function (Patch_Resource) {
    let patchSrv = {};

    patchSrv.list = function () {
      return Patch_Resource.list().$promise;
    }

    return patchSrv;
  }
]);




// WEBPACK FOOTER //
// ./js/services/models/Patch.js